<div class="layout" [class.sidebar-open]="sidebarOpen">
  <div class="sidebar-overlay" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>

  <aside class="sidebar" [class.open]="sidebarOpen">
    <div class="brand">
      <img src="advcare.png" alt="AdvCare" class="brand-logo" />
    </div>

    <nav class="menu">
      <a routerLink="/beneficiarios" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Beneficiarios</a>
      <a routerLink="/atendimentos" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Atendimentos</a>
      <a routerLink="/carregamento" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Carregamento</a>
      <a *ngIf="isAdmin" routerLink="/carregamento/monitoramento" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Monitoramento</a>
      <a *ngIf="isAdmin" routerLink="/beneficiario/monitoramentografico" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Grafico</a>
      <a *ngIf="isAdmin" routerLink="/monitoramento/quantitativo" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Quantitativo</a>
      <a *ngIf="isAdmin" routerLink="/monitoramento/quantitativo-atualizado" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Quantitativo atualizado</a>
      <a *ngIf="isAdmin" routerLink="/monitoramento/impacto-custos" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Impacto em custos</a>
      <a *ngIf="isAdmin" routerLink="/monitoramento_resposta" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Monitoramento resposta</a>
      <a *ngIf="isAdmin" routerLink="/admin/usuarios" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Usuarios</a>
      <a *ngIf="isAdmin" routerLink="/admin/documentos" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Criar documentos</a>
      <a *ngIf="isAdmin" routerLink="/admin/perguntas" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Criar perguntas</a>
    </nav>
  </aside>

  <div class="content-wrapper">
    <header class="topbar">
      <button class="hamburger" (click)="toggleSidebar()" [class.active]="sidebarOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div>
        <h2>Area autenticada</h2>
        <p>Usuario autenticado</p>
      </div>

      <div class="user-box">
        <span class="avatar">{{ initials }}</span>
        <div>
          <strong>{{ user?.name || 'Usuario' }}</strong>
          <small>{{ isAdmin ? 'Administrador' : 'Usuario' }}</small>
        </div>
        <button type="button" class="theme-btn" (click)="toggleTheme()">
          {{ isDarkTheme ? 'Modo claro' : 'Modo escuro' }}
        </button>
        <button type="button" class="logout-btn" (click)="logout()">Sair</button>
      </div>
    </header>

    <main class="content">
      <router-outlet></router-outlet>
    </main>

    <footer class="footer">© 2026 AdvCare • Sistema interno</footer>
  </div>
</div>

